import React from 'react';
import { Link } from 'react-router-dom';
import './styles/kursus.css';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useState, useEffect } from 'react';

function Kursus() {
  const [kurser, setKurser] = useState([]);

  useEffect(() => {
    const hentKurser = async () => {
      const kurserCollection = collection(db, 'kurser');
      const data = await getDocs(kurserCollection);
      const aktiveKurser = data.docs
        .map(doc => ({ ...doc.data(), id: doc.id }))
        .filter(kursus => !kursus.erSlettet);
      setKurser(aktiveKurser);
    };

    hentKurser();
  }, []);

  return (
    <>      
      <div className="kurser-kursus-container">
        <div className="kurser-kursus-header">
          <h1>Kurser</h1>
          <p>Specialiserede kurser der styrker din virksomheds kompetencer</p>
        </div>
        
        <div className="kurser-kursus-list">
          {kurser.map(kursus => (
            <div key={kursus.id} className="kurser-kursus-item">
              <img src={kursus.billedeUrl} alt={kursus.navn} className="kurser-kursus-image" />
              <div className="kurser-kursus-content">
                <h2>{kursus.navn}</h2>
                <p>{kursus.beskrivelse}</p>
                <Link to={`/kursus/${kursus.slug}`} className="kurser-kursus-book-button">
                  Book kursus
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Kursus;
